export default "__VITE_ASSET__BPWuDNIG__"